





import { sanitizeFilename } from "../sanitizeFilename";
import {
  splitExplainDifferentlySections,
} from "../../explain-differently/splitExplainDifferentlySections";

function sectionToBullets(section) {
  const bullets = [`[${section.title}]`];

  if (section.body) {
    bullets.push(section.body);
  }

  if (section.fields) {
    for (const field of section.fields) {
      bullets.push(`${field.label} ${field.body}`);
    }
  }

  if (section.vocabulary) {
    for (const item of section.vocabulary) {
      bullets.push(`${item.term} ${item.definition}`);
    }
  }

  if (section.misconception) {
    bullets.push(`Misconception: ${section.misconception}`);
  }

  if (section.extension) {
    bullets.push(`Extension: ${section.extension}`);
  }

  if (section.quickChecks) {
    bullets.push(...section.quickChecks);
  }

  if (section.tip) {
    bullets.push(`Tip: ${section.tip}`);
  }

  return bullets;
}

function strategyToBullets(strategy, options = {}) {
  const sections =
    options.sheet === "teacher"
      ? splitExplainDifferentlySections(strategy.sections).teacherSections
      : options.sheet === "handout"
        ? splitExplainDifferentlySections(strategy.sections).handoutSections
        : strategy.sections;

  return sections.flatMap(sectionToBullets);
}

export function explainDifferentlyToPptDocument(
result,
options = {})
{
  const sheet = options.sheet ?? "teacher";
  const slides = [
  {
    kind: "title",
    title: result.pageTitle,
    subtitle: result.topicLabel
  },
  ...result.strategies.map((strategy) => ({
    kind: "bullets",
    title: strategy.strategyLabel,
    bullets: strategyToBullets(strategy, { sheet })
  })),
  ...result.contextCards.map((card) => ({
    kind: "bullets",
    title: card.title,
    bullets: [card.body]
  }))];


  const filenameBase = `${result.topicLabel} explain differently`;

  return {
    filename: sanitizeFilename(filenameBase, "explain-differently"),
    title: result.pageTitle,
    subject: result.topicLabel,
    author: "Tema Explain Differently",
    slides
  };
}